// Form styles contained here
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Theme, VFlex, HFlex, GreenButton, GreenOutlineButton } from './styles';

// Wrapper for the whole form
export const FormContainer = styled.div`
  max-width: 660px;
  margin: 0 auto;
  width: 80%;
  padding-top: 50px;
  padding-bottom: 50px;

  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 40px;
    padding-bottom: 40px;

    margin-left: 0;
    margin-right: 0;
    width: 100%;
  }
`;

export const FormSection = styled.div`
  border-bottom: ${(props) => (props.last ? '0px' : '1px')} solid
    ${Theme.colors.dividerInactionableFieldColor};
`;

export const FormHeading = styled.h2`
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 600;
  font-family: 'soleil';
  color: ${Theme.colors.primaryTextColor};
`;

// To wrap around each section that needs space around it
// Usually contains one field, or a few horizontally in columns (using Column component below)
export const FieldSection = styled(VFlex)`
  border-bottom: ${(props) =>
    props.borderBottom
      ? `1px solid ${Theme.colors.dividerInactionableFieldColor}`
      : '0'};
  margin-bottom: ${(props) => props.marginBottom || '0'}px;
  padding-bottom: ${(props) => props.paddingBottom || '0'}px;
  flex-direction: ${(props) => (props.row ? 'row' : 'column')};
  align-items: flex-start;
`;

// Label for a FieldSection
export const Label = styled.div`
  margin-bottom: 15px;
  font-size: 16px;
  font-weight: 500;
  color: ${Theme.colors.primaryTextColor};
  &:first-letter {
    text-transform: uppercase;
  }
`;

export const SubLabel = styled(Label)`
  font-size: 14px;
  color: ${Theme.colors.secondaryTextColor};
  line-height: 150%;
  font-weight: 400;
`;

export const Column = styled.div`
  width: 50%;
  margin-right: ${(props) => (props.withMarginRight ? '20px' : '0px')};
`;

// Field CSS styles =====
export const TextField = css`
  width: 100%;
  padding-top: 14px;
  padding-bottom: 14px;
  padding-left: 10px;
  padding-right: 10px;

  box-sizing: border-box;
  border: 1px solid ${Theme.colors.inputs.border};
  border-radius: 0px;
  font-size: 14px;
  background: white;

  &::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: ${Theme.colors.inputs.placeholder};
  }
  &::-moz-placeholder {
    /* Firefox 19+ */
    color: ${Theme.colors.inputs.placeholder};
  }
  &:-ms-input-placeholder {
    /* IE 10+ */
    color: ${Theme.colors.inputs.placeholder};
  }
  &:-moz-placeholder {
    /* Firefox 18- */
    color: ${Theme.colors.inputs.placeholder};
  }
`;

export const TextAreaField = css`
  ${TextField}
  height: 180px;
`;
// ===== Field CSS styles

// Error message attached to bottom of input fields
export const Error = styled.div`
  width: 100%;
  padding: 3px;
  padding-left: 10px;
  padding-right: 10px;
  font-size: 14px;
  color: white;
  background-color: ${Theme.colors.errorRedColorDark};
  margin-bottom: ${(props) => (props.noMargin ? '0' : '30px')};
`;

export const Actions = styled(HFlex)`
  justify-content: center;
  width: 100%;
  margin-top: 40px;
`;

export const SubmitButton = styled(GreenButton)`
  width: 150px;
  font-size: 16px;
  padding-left: 30px;
  padding-right: 30px;
  @media (max-width: 580px) {
    font-size: 15px;
  }
`;

export const OutlineButton = styled(GreenOutlineButton)`
  font-size: 16px;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-right: 15px;
  padding-left: 15px;
  height: ${Theme.forms.dimensions.inputHeight}px;
  i {
    font-size: 15px;
  }
  :visited,
  :hover,
  :active {
    color: ${Theme.colors.linksDesignElementsBaseColor};
  }
  :hover {
    background-color: ${Theme.colors.backgroundColor};
  }
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    font-size: 15px;
  }
`;
